import { analytics } from "./analyticsManager";
var alertTopic = analytics.createTopic();
var flow = "main";
var application = "portal";
var step = "alert";
export var analyticsAlertShow = function (type) {
    alertTopic.sendEvent("show_alert", { application: application, step: step, flow: flow, type: type });
};
export var analyticsAlertClose = function (type) {
    alertTopic.sendEvent("click_cta", {
        application: application,
        step: step,
        flow: flow,
        type: type,
        result: "close_alert",
    });
};
export var analyticsAlertClick = function (type) {
    alertTopic.sendEvent("click_cta", {
        application: application,
        step: step,
        flow: flow,
        type: type,
        result: "click_alert",
    });
};
